export default {"src":"/app/_next/static/media/boxes_top.8e9de2ed.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};